import { createReducer } from "@reduxjs/toolkit";
import { AUTH_ERROR, LOGIN_SUCCESS, LOGOUT_SUCCESS, USER_LOADED } from "../actions/auth";


const initialState = {
  token: localStorage.getItem("socketToken"),
  isAuthenticated: false,
  isLoading: true,
  user: null,
  error: false,
  needsVerification: false,
};

const authReducer = createReducer(initialState, (builder) => {
  builder

    .addCase(USER_LOADED, (state, { payload }) => {
      localStorage.setItem("isLoggedIn", true);
      localStorage.setItem("user", JSON.stringify(payload.user));
      state.isAuthenticated = true;
      state.isLoading = false;
      state.user = payload.user;
      state.token = payload.token;
      state.error = false;
    })

    .addCase(LOGIN_SUCCESS, (state, { payload }) => {
      localStorage.setItem("socketToken", payload.token);
      localStorage.setItem("user", JSON.stringify(payload.user));
      localStorage.setItem("isLoggedIn", true);
      state.isAuthenticated = true;
      state.isLoading = false;
      state.user = payload.user;
      state.token = payload.token;
      state.error = false;
    })
    .addCase(AUTH_ERROR, (state, { payload }) => {
      localStorage.removeItem("socketToken");
      localStorage.removeItem("user");
      localStorage.removeItem("fbToken");
      localStorage.setItem("isLoggedIn", false);
      localStorage.removeItem("isLoggedIn");
      state.isAuthenticated = false;
      state.isLoading = false;
      state.user = null;
      state.token = null;
      state.error = payload;
    })
    .addCase(LOGOUT_SUCCESS, (state) => {
      localStorage.removeItem("socketToken");
      localStorage.removeItem("user");
      localStorage.removeItem("fbToken");
      localStorage.setItem("isLoggedIn", false);
      localStorage.removeItem("isLoggedIn");
      state.isAuthenticated = false;
      state.isLoading = false;
      state.user = null;
      state.token = null;
      state.error = false;
    });
});

export default authReducer;
